import proptypes from 'prop-types';

const { shape, string } = proptypes;

const openCloseShape = shape({
  open: string,
  close: string
});

export const storeShape = shape({
  address: shape({
    city: string,
    postalCode: string,
    state: string,
    street: string
  }),
  distance: string,
  name: string,
  proDeskPhone: string,
  storeDetailsPageLink: string,
  storeId: string,
  storeHours: shape({
    sunday: openCloseShape,
    monday: openCloseShape,
    tuesday: openCloseShape,
    wednesday: openCloseShape,
    thursday: openCloseShape,
    friday: openCloseShape,
    saturday: openCloseShape
  }),
  storeServicesPhone: string,
  toolRentalPhone: string
});
